import { formatDistanceToNowStrict } from "date-fns";
import { formatCompactCurrency, formatCurrency, formatEnumLabel } from "./utils";

export { formatCompactCurrency, formatCurrency, formatEnumLabel };

export function formatRelativeTime(input: Date | string | null | undefined) {
  if (input === null || input === undefined || input === "") return "—";
  const value = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(value.getTime())) return "—";
  return formatDistanceToNowStrict(value, { addSuffix: true });
}

/**
 * Safely format a date using toLocaleString
 */
export function safeDateLocale(
  date: string | Date | null | undefined,
  options?: Intl.DateTimeFormatOptions | string
): string {
  if (!date) return "N/A";
  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) return "Invalid date";
    if (typeof options === "string") {
      return dateObj.toLocaleString(options);
    }
    return dateObj.toLocaleString("en-NG", options);
  } catch {
    return "Invalid date";
  }
}

export function safeNumber(value: unknown, fallback = 0) {
  const parsed =
    typeof value === "number"
      ? value
      : typeof value === "string"
        ? Number.parseFloat(value)
        : Number.NaN;

  return Number.isFinite(parsed) ? parsed : fallback;
}